import { Edit } from '@mui/icons-material';
import {
  IconButton,
  Stack,
  TableCell,
  TableRow,
  Typography,
} from '@mui/material';
import React, { Dispatch, SetStateAction, useState } from 'react';
import EditCompanyDialog from './EditCompanyModal';
import { CompanyData } from '../types';
import { primaryRed } from '@styles/colors';

function UploadedCompaniesRow({
  item,
  index,
  setModifiedComapiesData,
}: {
  item: CompanyData;
  setModifiedComapiesData: Dispatch<SetStateAction<CompanyData[]>>;
  index: number;
}) {
  const [openEdit, setOpenEdit] = useState(false);
  const isInvalid = Boolean(item.status === 'Invalid Address');
  const handleSave = (updatedCompany: CompanyData) => {
    setModifiedComapiesData((prev) =>
      prev.map((comp, i) => (i === index ? updatedCompany : comp)),
    );
    setOpenEdit(false);
  };
  return (
    <>
      <TableRow
        hover={Boolean(item.status !== 'Invalid Address')}
        sx={{
          backgroundColor:
            isInvalid ? primaryRed : 'inherit',
          '& td': {
            color: isInvalid ? 'white' : 'inherit',
          },
        }}
      >
        <TableCell>{index + 1}</TableCell>
        <TableCell>{item.email}</TableCell>
        <TableCell>{item.user_name}</TableCell>
        <TableCell>{item.company_name}</TableCell>
        <TableCell>{item.street_address}</TableCell>
        <TableCell>{item.city}</TableCell>
        <TableCell>{item.state}</TableCell>
        <TableCell>{item.zip_code}</TableCell>
        <TableCell>
          <Stack direction="row">
            <IconButton onClick={() => setOpenEdit(true)} color={isInvalid ? "inherit": "primary"}>
              <Edit />
            </IconButton>
          </Stack>
        </TableCell>
      </TableRow>
      {openEdit && (
        <EditCompanyDialog
          open={openEdit}
          handleClose={() => setOpenEdit(false)}
          company={item}
          onSave={handleSave}
        />
      )}
    </>
  );
}

export default UploadedCompaniesRow;
